import React from "react";
import { Spin, Alert } from "antd";
import { useTranslation } from "react-i18next";
import { TestStartSectionProps } from "../../../../types/installationTest";

export const TestStartSection: React.FC<TestStartSectionProps> = ({
  onStartTest,
  loading,
  hasResults = false,
}) => {
  const { t } = useTranslation("settings");

  return (
    <div className="test-start-section">
      {!hasResults && <p>{t("installation_test_description")}</p>}
      <button
        className="start-test-btn"
        onClick={onStartTest}
        disabled={loading}
      >
        {loading ? <Spin size="small" /> : hasResults ? t("run_new_test") : t("start_installation_test")}
      </button>
    </div>
  );
};
